import Container from 'elements/Container'
import React, { useState, Suspense, lazy } from 'react'
import { TAB } from './tab.enum'
import { isMobile } from 'react-device-detect'
import {
  Grid,
  Padder,
  RelativeWrapper,
  SelectionTitle,
  Selection,
  Option,
  Tabs,
  TabItem,
  BannerWrapper
} from './styled'
import { humanize, mapTabEnum } from './utils'
import Fallback from 'components/Fallback'
import bannerTeam from 'assets/images/banner-team.png'

const Profile = lazy(() => import('./Profile'))

const Teams = (): JSX.Element => {
  const [tab, setTab] = useState<TAB>(TAB.ALL)
  const [openTab, setOpenTab] = useState(false)

  const handleTab = (tabType: TAB): void => {
    setTab(tabType)
    setOpenTab(false)
  }

  return (
    <Suspense fallback={Fallback}>
      <Container>
        <BannerWrapper>
          <img width="100%" src={bannerTeam} alt="banner" />
        </BannerWrapper>
        <Padder>
          {isMobile ? (
            <RelativeWrapper>
              <SelectionTitle openTab={openTab} onClick={() => setOpenTab(prev => !prev)}>
                {humanize(tab.toLowerCase())}
              </SelectionTitle>
              <Selection openTab={openTab} many={Object.keys(TAB).length}>
                {mapTabEnum(TAB, (position: TAB) => (
                  <Option key={position} onClick={() => handleTab(TAB[position])}>
                    {humanize(TAB[position].toLowerCase())}
                  </Option>
                ))}
              </Selection>
            </RelativeWrapper>
          ) : (
            <Tabs>
              {mapTabEnum(TAB, (position: TAB) => (
                <TabItem key={position} active={tab === TAB[position]} onClick={() => handleTab(TAB[position])}>
                  {humanize(TAB[position].toLowerCase())}
                </TabItem>
              ))}
            </Tabs>
          )}
        </Padder>
        <Grid>
          <Profile tab={tab} />
        </Grid>
      </Container>
    </Suspense>
  )
}

export default Teams
